import request from "@/libs/request";
import ssoRequest from "@/libs/ssoRequest";

export const DoLogin = async (params: string) =>
  request.post(`/compute`, { input: params });

export const DoLogout = async () =>
  request.post(`/compute`, { input: "auth.sign_out()" });

export const DoSsoLogin = async () => ssoRequest.get(`/sso/login`);
